"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleDataFilterClause = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRuleDataFilterClause extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.type = obj.type;
            this.annotation = obj.annotation;
            this.acceptCondition = obj.acceptCondition;
            this.rejectCondition = obj.rejectCondition;
            this.recordGeneration = obj.recordGeneration;
            this.clauseNumber = obj.clauseNumber;
        }
    }
}
exports.MarketRuleDataFilterClause = MarketRuleDataFilterClause;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtZGF0YS1maWx0ZXItY2xhdXNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS1kYXRhLWZpbHRlci1jbGF1c2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEseURBQW9EO0FBRXBELE1BQWEsMEJBQTJCLFNBQVEsaUNBQWM7SUFRMUQ7OztPQUdHO0lBQ0gsWUFBbUIsR0FBeUM7UUFDeEQsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBRVgsSUFBSSxHQUFHLEVBQUUsQ0FBQztZQUNOLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLElBQUssQ0FBQztZQUN0QixJQUFJLENBQUMsVUFBVSxHQUFHLEdBQUcsQ0FBQyxVQUFXLENBQUM7WUFDbEMsSUFBSSxDQUFDLGVBQWUsR0FBRyxHQUFHLENBQUMsZUFBZ0IsQ0FBQztZQUM1QyxJQUFJLENBQUMsZUFBZSxHQUFHLEdBQUcsQ0FBQyxlQUFnQixDQUFDO1lBQzVDLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxHQUFHLENBQUMsZ0JBQWlCLENBQUM7WUFDOUMsSUFBSSxDQUFDLFlBQVksR0FBRyxHQUFHLENBQUMsWUFBYSxDQUFDO1FBQzFDLENBQUM7SUFDTCxDQUFDO0NBQ0o7QUF4QkQsZ0VBd0JDIn0=